import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import SectionHeadline from 'shared/components/SectionHeadline';
import GroupOptionsConfig from 'shared/components/GroupOptionsConfig';
import { colors, fonts, fontSizes } from 'shared/defaultTheme';

import { ReactComponent as InformationIcon } from 'assets/icon-information.svg';

const ConfigSyncClientLinkWrapper = styled.div`
  width: 100%;
  .what-is-client-link-container {
    height: 28px;
    width: 150px;
    border-radius: 2px;
    background-color: ${colors.bilbao};
    color: ${colors.white};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    fill: ${colors.white};
    &:hover {
      border: 1px solid;
      border-radius: 2px;
      background-color: ${colors.white};
      border-color: ${colors.bilbao};
      color: ${colors.bilbao};
      fill: ${colors.bilbao};
    }
    .what-is-client-link-information-icon {
      height: 20px;
      width: 20px;
    }
  }

  .no-have-contract-client-link-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    flex-direction: column;
    .no-have-contract-client-link-information-icon {
      height: 29px;
      width: 29px;
      fill: ${colors.lightBlue};
    }
    .no-have-contract-client-link-span {
      color: ${colors.lightBlue};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
    .no-have-contract-client-link-btn {
      height: 28px;
      width: 172px;
      border-radius: 2px;
      background-color: ${colors.lightBlue};
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${colors.white};
      box-shadow: 0 1px 1px 0 ${colors.pattens};
      cursor: pointer;
      &:hover {
        border: 1px solid;
        border-radius: 2px;
        background-color: ${colors.white};
        border-color: ${colors.lightBlue};
        color: ${colors.lightBlue};
      }
    }
  }
`;

const ConfigSyncClientLink = ({
  mainColor,
  setSelectedConfigOption,
  selectedConfigOption,
  hasCLientLink,
}) => {
  const { t } = useTranslation();

  const ConfigSyncClientLinkOptions = [
    {
      name: t('general_customizer_option_not_sync'),
      value: 0,
    },
    {
      name: t('general_customizer_option_sync_auto'),
      value: 1,
    },
    {
      name: t('general_customizer_option_sync_manual'),
      value: 2,
    },
  ].filter((option) => option.value === selectedConfigOption);

  const onClickConfigOption = (value) => setSelectedConfigOption(value);

  return (
    <ConfigSyncClientLinkWrapper>
      <SectionHeadline
        className="general-customizer__section-headline-2"
        sectionNumber={5}
        label={t('general_config_sync_client_link')}
        color={mainColor}
      />
      {hasCLientLink ? (
        <>
          <div className="general-customizer__switch-footer-logo-wrapper mb-3">
            <GroupOptionsConfig
              options={ConfigSyncClientLinkOptions}
              onClick={onClickConfigOption}
              selectedOption={selectedConfigOption}
              isDisable
            />
          </div>
          <div>
            <div
              className="what-is-client-link-container"
              aria-hidden="true"
              onClick={() => {
                window.open(`https://ecosistema.lefebvre.es/client-link-simulador/`, '_blank');
              }}
            >
              <InformationIcon className="what-is-client-link-information-icon mr-1" />
              <span className="mb-n1">{t('general_config_what_is_client_link')}</span>
            </div>
          </div>
        </>
      ) : (
        <div className="no-have-contract-client-link-container">
          <div className="d-flex align-items-center mb-3">
            <InformationIcon className="no-have-contract-client-link-information-icon mr-1 mb-1" />
            <span className="no-have-contract-client-link-span">
              {t('general_no_have_contract_clint_link')}
            </span>
          </div>
          <div>
            <div
              className="no-have-contract-client-link-btn"
              aria-hidden="true"
              onClick={() => {
                window.open(`https://ecosistema.lefebvre.es/client-link-simulador/`, '_blank');
              }}
            >
              {t('general_request_info')}
            </div>
          </div>
        </div>
      )}
    </ConfigSyncClientLinkWrapper>
  );
};

ConfigSyncClientLink.defaultProps = {
  mainColor: '',
  setSelectedConfigOption: undefined,
  selectedConfigOption: undefined,
};

ConfigSyncClientLink.propTypes = {
  mainColor: PropTypes.string,
  selectedConfigOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSelectedConfigOption: PropTypes.func,
  hasCLientLink: PropTypes.bool.isRequired,
};

export default ConfigSyncClientLink;
